import "../../data/css/SideNavbar.scss"
import {useGlobal} from "../../contexts/GlobalContext";
import {WiDayCloudy, SiAboutDotMe, FaCompass, AiFillGithub, FiMessageSquare} from "react-icons/all";
import SideNavbarLink from "./SideNavbarLink";
import {createHashHistory} from 'history'

function SideNavbar() {

    const {isSideBarShow, setSideBarShow, activeSite, setActiveSite, isMobile} = useGlobal()
    const history = createHashHistory()

    const textShow = () => isSideBarShow ? "sidenav-text-show" : "sidenav-text-hide"

    const toggleNavbar = () => setSideBarShow(!isSideBarShow)
    const setMainColor = () => "" === activeSite ? "sidenav-main-active" : ""

    const onClick = (href) => {
        setMain()
        if (isMobile) setSideBarShow(false)
    }

    const setMain = () => {
        history.push("/")
        setActiveSite("")
    }


    return (
        <div className={`sidenav ${isSideBarShow ? "sidenav-show" : "sidenav-hide"} aalp2`}>

            <h5 className={"sidenav-logo d-inline"} onClick={toggleNavbar}><FaCompass size={"2rem"}/></h5>
            {isSideBarShow && <h5 className={`d-inline jk ${textShow()} ${setMainColor()}`} onClick={onClick}>
                &nbsp; Jakub Kwiatkowski
            </h5>}
            <SideNavbarLink href={"about"} text={"About"} icon={SiAboutDotMe}/>
            <SideNavbarLink href={"github"} text={"Github"} icon={AiFillGithub}/>
            <SideNavbarLink href={"weather"} text={"Weather"} icon={WiDayCloudy}/>
            <SideNavbarLink href={"contact"} text={"Contact"} icon={FiMessageSquare}/>
        </div>

    );
}

export default SideNavbar;
